// If you're reusing colors or font sizes, please add them here!
// But if the value is similar to one that's already here, please use that instead,
// code reuse will make it way easier to do complex theming in the future
// See media.css for @media breakpoints
// Using a JS file for now until we figure out how to use to-string-loader for everything BUT a media.css file
export default {
  '--primary-color': '#4399df',
  '--text-color': 'white',
  '--error-text-color': '#ff4444',
  '--button-background-white': 'rgba(255, 255, 255, 0.4)',
  '--button-background-light': 'rgba(255, 255, 255, 0.1)',
  '--button-background-light-dark': 'rgba(0, 0, 0, 0.4)',
  '--button-background': 'rgba(0, 0, 0, 0.6)',
  '--button-background-dark': 'rgba(0, 0, 0, 0.8)',
  '--button-border-light': 'rgba(0, 0, 0, 0.3)',
  '--button-border-light-dark': 'rgba(10, 10, 10, 0.2)',
  '--black-shadow': 'rgba(0, 0, 0, 0.5)',
  '--main-font': 'Nunito Sans, sans-serif',
  // TODO: Responsive font sizes?
  '--small-font-size': '14px',
  '--main-font-size': '16px',
  '--large-font-size': '18px',
  '--xlarge-font-size': '24px',
  '--title-font-size': '28px',
  '--color-one': '#ea4335',
  '--color-two': '#4285f4',
  '--color-three': '#34a853',
  '--color-four': '#fbbc05',
  '--size': 14,
};
